import React from "react";
import { message } from "antd";
import { Drawer } from "antd";
import { Form, Button, Icon } from "antd";

import LayoutDefault from "../../shared/LayoutDefault";

import LicenseTable from "./LicenseTable";
import LicenseForm from "./LicenseForm";

class LicenseView extends React.Component {
  static defaultProps = {
    onCreate: async (row) => {},
    onUpdate: async (row) => {},
    onDelete: async (row) => {},
  };

  state = {
    loading: false,
    edit: undefined,
    create: undefined,
  };

  handleCreateRequested = () => {
    this.setState({ create: new Date() });
  };

  handleCreateCancelled = () => {
    this.setState({ create: undefined });
  };

  handleCreateSubmitted = async (values) => {
    this.setState({ loading: true });
    const errors = await this.props.onCreate(values);
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    this.setState({ create: undefined });
    message.success("The license has been created");
  };

  handleEditRequested = (row) => {
    this.setState({ edit: row });
  };

  handleEditCancelled = () => {
    this.setState({ edit: undefined });
  };

  handleEditSubmitted = async (values) => {
    const {
      edit: { id },
    } = this.state;
    this.setState({ loading: true });
    const errors = await this.props.onUpdate({ ...values, id });
    this.setState({ loading: false });
    if (errors) {
      return errors;
    }
    message.success("The license has been updated");
  };

  handleDeleteConfirmed = async (row) => {
    this.setState({ loading: true });
    await this.props.onDelete(row);
    message.success("The license has been deleted");
    this.setState({ loading: false });
  };

  render() {
    const {
      data: { licenseSet, loading: dataLoading },
    } = this.props;

    const { create, edit, loading } = this.state;

    return (
      <LayoutDefault>
        {!dataLoading && (
          <React.Fragment>
            <Form.Item>
              <Button
                size="small"
                onClick={this.handleCreateRequested}
                loading={loading}
              >
                <Icon type="plus" />
                Create a license
              </Button>
            </Form.Item>

            <LicenseTable
              licenseSet={licenseSet}
              loading={loading}
              onEdit={this.handleEditRequested}
              onDelete={this.handleDeleteConfirmed}
            />

            <Drawer
              visible={!!create}
              title="Create license"
              onClose={this.handleCreateCancelled}
              width="60%"
            >
              <LicenseForm
                key={create}
                row={{}}
                loading={loading}
                onSubmit={this.handleCreateSubmitted}
              />
            </Drawer>

            <Drawer
              visible={!!edit}
              title={edit && `Edit ${edit.name}`}
              onClose={this.handleEditCancelled}
              width="60%"
            >
              {edit && (
                <LicenseForm
                  row={edit}
                  loading={loading}
                  onSubmit={this.handleEditSubmitted}
                />
              )}
            </Drawer>
          </React.Fragment>
        )}
      </LayoutDefault>
    );
  }
}

export default LicenseView;
